import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import App from '../App';
import PaymentSuccessPage from './PaymentSuccessPage';

/* `<Navigate to="/en">` drops the query string, which silently ate the params the app
   needs on entry - the password-reset token (/?reset=1&token=...) and the OAuth
   /?login=success marker. Carry search and hash across the language redirect. */
const RedirectToDefaultLang = () => {
  const { search, hash } = useLocation();
  return <Navigate to={`/en${search}${hash}`} replace />;
};

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Route par défaut - redirige vers /en */}
        <Route path="/" element={<RedirectToDefaultLang />} />
        
        {/* Routes avec langue */}
        <Route path="/:lang/*" element={<App />} />
        <Route path="/:lang/payment/success" element={<PaymentSuccessPage />} />
        
        {/* Fallback pour les langues non supportées */}
        <Route path="*" element={<RedirectToDefaultLang />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
